import * as THREE from "three";
import { ChartBar } from "./ENTITIES/ChartBar";
import { createLabel } from "../../TOOLS/LabelFactory";

export class Charts {

    constructor(store) {
        this.store = store;
        this.group = new THREE.Group();
        this.colors = [0x3498db, 0xe67e22, 0x2ecc71, 0xf1c40f,  0x9b59b6, 0xe74c3c, 0x1abc9c];
        this.cityGroups = new Map();
        this.chartBars = [];
    }

    render(chartArray) {
        if(this.store.level.chartType === 'DISTRICTYEARS'){
            chartArray.forEach(data => {
            const headoffice = this.store.database.headoffices.find(office => office.districtid === data.districtid);
            if (!headoffice) return;
            const plant = Object.keys(data.plants)[0];
            const years = Object.keys(data.plants[plant]);
            years.forEach((year, index) => {
                const value = Number(data.plants[plant][year]) || 0;
                const height = this.scaleBar(value);
                const chartBar = new ChartBar(this.store, this.store.ui.group, data.districtid, .3, height, plant, year, Math.round(value), this.colors[index % this.colors.length]);
                this.chartBars.push(chartBar)
                // Az egyes évek egymás mellé kerülnek
                chartBar.group.position.set(Number(headoffice.threeX) + index * .4, 0.5, Number(headoffice.threeZ));
            });
        });
        }else if(this.store.level.chartType === 'DISTRICTPLANTS'){
            chartArray.forEach((data) => {
                const headoffice = this.store.database.headoffices.find(office => office.districtid === data.districtid);
                if (!headoffice) return;
                
                const plants = Object.keys(data.plants).forEach((plant, index) => {
                    const year = Object.keys(data.plants[plant])[0];
                    const value = Object.entries(data.plants[plant])[0][1];
                    const height = this.scaleBar(value);
                    const chartBar = new ChartBar(this.store, this.store.ui.group, data.districtid, .3, height, plant, year, Math.round(value), this.colors[index % this.colors.length]);
                    this.chartBars.push(chartBar)
                    // Az egyes évek egymás mellé kerülnek
                    chartBar.group.position.set(Number(headoffice.threeX) + index * .4, 0.5, Number(headoffice.threeZ));
                })
            });
        }else if(this.store.level.chartType === 'CITYPLANTS'){
            chartArray.forEach((data) => {
                const city = this.store.database.cities.find(city => city.id === data.cityid);
                if (!city) return;
                const plants = Object.keys(data.plants).forEach((plant, index) => {
                    const entries = Object.entries(data.plants[plant]);
                    if (entries.length === 0 || Array.isArray(entries[0][1]) && entries[0][1].length === 0) {
                        return;
                    }
                    const year = Object.keys(data.plants[plant])[0];
                    const value = Object.entries(data.plants[plant])[0][1];
                    if (value <= 0) return;
                    const height = this.scaleBar(value);
                    const cityGroup = this.getCityGroup(city);
                    const chartBar = new ChartBar(this.store, cityGroup, data.cityid, 0.15, height, plant, year, Math.round(value), this.colors[index % this.colors.length], city);
                    this.chartBars.push(chartBar)
                    // Az egyes évek egymás mellé kerülnek
                    chartBar.group.position.set(index * 0.2, 0.5, 0);
                })
                
            });
        }else if(this.store.level.chartType === 'CITYYEARS'){
            chartArray.forEach(data => {
            const city = this.store.database.cities.find(city => city.id === data.cityid);
            if (!city) return;
            const plant = Object.keys(data.plants)[0];  
            const years = Object.keys(data.plants[plant]);
                years.forEach((year, index) => {
                    const value = Number(data.plants[plant][year]) || 0;
                    if (value <= 0) return;
                    const height = this.scaleBar(value);
                    const cityGroup = this.getCityGroup(city);
                    const chartBar = new ChartBar(this.store, cityGroup, data.cityid, 0.15, height, plant, year, Math.round(value), this.colors[index % this.colors.length], city);
                    this.chartBars.push(chartBar)   
                    // Az egyes évek egymás mellé kerülnek
                    chartBar.group.position.set(index * 0.2, 0.5, 0);
                });
            });
        }
    }

    scaleBar(value) {
        const minValue = this.store.level.chartMin;
        const maxValue = this.store.level.chartMax;
        const normalized = (value - minValue) / (maxValue - minValue);
        return 1 + normalized * 6;
    }

    getCityGroup(city) {
        if (this.cityGroups.has(city.id)) {return this.cityGroups.get(city.id);}
        const group = new THREE.Group();
        group.position.set(Number(city.threeX), 0, Number(city.threeZ));
        const label = createLabel(city.name, {fontSize: 16, position: new THREE.Vector3(0, .5, -.5)});
        group.add(label);
        this.store.ui.group.add(group);
        this.cityGroups.set(city.id, group);
        return group;
    }

    update() {
        this.chartBars.forEach(chartBar => {chartBar.update();});
    }
    
    dispose() {
        // ChartBar objektumok eltávolítása
        this.chartBars.forEach(chartBar => {chartBar.dispose();});
        this.chartBars = [];

        // CityGroup objektumok és labeljeik eltávolítása
        this.cityGroups.forEach(group => {
            group.traverse(object => {
                if (object.geometry) {object.geometry.dispose();}
                if (object.material) {
                    if (Array.isArray(object.material)) {object.material.forEach(material => material.dispose());
                    } else {object.material.dispose();}
                }
            });
            group.removeFromParent();
        });
        this.cityGroups.clear();
    }
}